/**
 * /intrebari-frecvente page bundle — migrated from public/js/questions.js.
 *
 * 4 sectiuni:
 *   1. Focus / blur pe inputs cu .lb-focused efect (pe parent <label>)
 *   2. .layer-1 accordion (toggle .opened si slideToggle pe <ul> copilul)
 *   3. .submenu navMenu pe '.group' panels
 *   4. #question-form — submitate NATIV (form-native-fix face Form() no-op)
 */

import { Resort } from '../core/resort.js';

new Resort(() => {
    /* Inputs focus/blur — aura pe parinte <label> */

    $('input[type="text"], textarea', true).on('focus', function (this: Element) {
        const p = this.parents('label') as HTMLElement | null;
        if (p && !p.classList.contains('lb-focused')) p.classList.add('lb-focused');
    });

    $('input[type="text"], textarea', true).on('blur', function (this: Element) {
        const p = this.parents('label') as HTMLElement | null;
        if (p?.classList.contains('lb-focused')) p.classList.remove('lb-focused');
    });

    /* Questions accordion */

    ($('.layer-1') as Element | null)?.on('click', 'li > a', function (this: Element) {
        this.classList.toggle('opened');
        const li = this.parents('li') as HTMLElement | null;
        const ul = li?.find('ul') as HTMLElement | null;
        ul?.slideToggle(function (this: HTMLElement, visible: boolean) {
            this.prev('a')?.classList.toggle('fill', visible);
        });
    });

    /* Submenu navMenu */

    ($('.submenu') as Element | null)?.navMenu('a', '.group');

    /*
     * #question-form — submit form-ul direct catre /message/send (PHP).
     * Resort.Form() ar fi interceptat submit + AJAX la /request (endpoint legacy
     * neexistent). Shim-ul integrat in Node.prototype.Form returneaza early
     * pentru form-uri cu method=post + action != '' (vezi form/form.ts).
     *
     * Codul de mai jos doar inregistreaza Form() ca no-op pentru compat. Nu e
     * strict necesar acum, dar pastreaza pattern-ul in caz ca cineva apeleaza
     * Form() pe alt form fara action.
     */
    const qForm = $('#question-form') as HTMLFormElement | null;
    if (qForm) {
        qForm.Form('form', 'question_send_msg', {}, {
            valid: () => ({
                name:    'min(5)max(40)',
                company: 'min(5)max(40)',
                email:   'mail(40)',
                phone:   'min(10)max(40)',
                message: 'nn()max(10000)',
            }),
            done: () => { /* no-op — submit-ul real e nativ catre /message/send */ },
        });
    }
});
